<script>
import {
  getValue,
  APP_PAGE_TYPE,
  DIALOG_TITLE_TYPE,
  UPLOAD_IMG_TYPE,
  APP_PAGE_STATUS
} from "@/utils/enumUtile";
import { formatApiDate, getFileName } from "@/utils/utils";
import {
  getCarouselList,
  carouselEdit,
  editCarouselStatus
} from "@/api/system";
import UploadList from "@/views/components/uploadList.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    APP_PAGE_TYPE() {
      return APP_PAGE_TYPE;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    UPLOAD_IMG_TYPE() {
      return UPLOAD_IMG_TYPE;
    },
    APP_PAGE_STATUS() {
      return APP_PAGE_STATUS;
    }
  },
  components: { UploadList },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        pageSize: 10,
        pageUi: "", // 显示页面：1-APP首页，2-APP分类页，3-商学院资讯
        status: "" //类型
      },
      form: {
        id: 0,
        imgUrl: [],
        pageUi: undefined,
        sort: undefined,
        goodsUrl: ''
      },
      rules: {
        pageUi: [
          { required: true, message: "显示页面类型不能为空", trigger: "change" }
        ],
        sort: [{ required: true, message: "排序不能为空", trigger: "change" }]
      },
      dialogStatus: "CREATE",
      dialogFormVisible: false,
      btnLoading: false
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      getCarouselList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    checkDialogFormVisible(status, obj = {}) {
      this.dialogFormVisible = status;
      if (status) {
        this.form = {
          id: obj.id,
          pageUi: obj.pageUi,
          status: obj.status,
          sort: obj.sort,
          goodsUrl: obj.goodsUrl
        };
        if (obj.carouselImage) {
          const attDataArr = [];
          attDataArr.push({
            url: obj.carouselImage,
            dbUrl: obj.carouselImage,
            name: getFileName(obj.carouselImage)
          });
          this.form.imgUrl = attDataArr;
        }
      } else {
        this.form = {
          id: 0,
          type: undefined,
          status: undefined,
          sort: undefined,
          imgUrl: [],
          goodsUrl: ''
        };
        this.$refs.form.resetFields();
      }
    },

    /**
     * 新增
     */
    saveData() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          const form = this.form;

          const params = {
            ...form
          };
          if (params.imgUrl && params.imgUrl.length !== 0) {
            const urlArr = params.imgUrl.map(obj => obj["dbUrl"]);
            params.imgUrl = urlArr.join(",");
          } else {
            this.$notify({
              title: "失败",
              message: "请上传图片",
              type: "error",
              duration: 2000
            });
            return;
          }

          this.btnLoading = true;
          carouselEdit(params)
            .then(() => {
              this.getList();
              this.checkDialogFormVisible(false, {});
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    /**
     * 确认上传音频
     * @param type
     * @param res
     */
    getAttDataValueFunc(type, res) {
      if (type === "imgUrl") {
        this.form.imgUrl = res;
      }
    },
    /**
     * 修改广告状态
     * @param scope
     */
    statusChange(scope) {
      const params = {
        id: scope.id,
        status: scope.status === 0 ? 1 : 0
      };
      editCarouselStatus(params).then(() => {
        this.getList();
        this.$notify({
          title: "成功",
          message: "状态编辑成功",
          type: "success",
          duration: 2000
        });
      });
    }
  }
};
</script>

<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.pageUi"
        placeholder="页面"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in APP_PAGE_TYPE"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 200px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in APP_PAGE_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true, {})"
        >新增</el-button
      >
    </div>

    <div style="margin-bottom: 5px">APP轮播图数量：{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      highlight-current-row
    >
      <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column>
      <el-table-column label="页面类型" align="center" prop="pageUi">
        <template slot-scope="scope">
          <span>{{ getValue(APP_PAGE_TYPE, scope.row.pageUi) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="图片地址" align="center" prop="carouselImage">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.carouselImage"
            style="width: 100px"
            fit="cover"
          />
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" prop="status">
        <template slot-scope="scope">
          <span>{{ getValue(APP_PAGE_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="排序"
        align="center"
        prop="sort"
      ></el-table-column>
      <el-table-column align="center" prop="created_at" label="创建时间">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="created_at" label="修改时间">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="180"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkDialogFormVisible(true, scope.row)"
            >编辑</el-button
          >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            title="确定要修改图状态吗？"
            @confirm="statusChange(scope.row)"
          >
            <el-switch
              :value="scope.row.status === 1"
              slot="reference"
              style="margin-left: 8px"
            ></el-switch>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    编辑和新增-->
    <el-dialog
      :title="DIALOG_TITLE_TYPE[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      @close="checkDialogFormVisible(false,{})"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="250px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="图" prop="imgUrl">
          <!--          <UploadList-->
          <!--            :typeProps="UPLOAD_IMG_TYPE.COMMON"-->
          <!--            paramsType="imgUrl"-->
          <!--            :model="form.imgUrl"-->
          <!--            @valueFunc="getAttDataValueFunc"-->
          <!--            :maxCount="1"-->
          <!--          />-->
          <UploadList
            :typeProps="UPLOAD_IMG_TYPE.COMMON"
            @valueFunc="getAttDataValueFunc"
            paramsType="imgUrl"
            :model="form.imgUrl"
            :maxCount="1"
          />
        </el-form-item>

        <el-form-item label="显示页面" prop="pageUi">
          <el-select
            v-model="form.pageUi"
            placeholder="请选择页面类型"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in APP_PAGE_TYPE"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="排序（值越大越靠前）" prop="sort">
          <el-input v-model="form.sort" placeholder="请输入排序" />
        </el-form-item>
        <el-form-item label="商品ID" prop="goodsUrl">
          <el-input v-model="form.goodsUrl" placeholder="请输入商品url" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false)">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss"></style>
